export default "__VITE_ASSET__QMID7Zdg__"